import * as Sentry from '@sentry/react'
import { config } from '../config'

const dsn = config.sentryDsn

export function initSentry() {
  if (!dsn) return

  Sentry.init({
    dsn,
    environment: config.sentryEnv,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({ maskAllText: false, blockAllMedia: false }),
    ],
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0,    // don't record normal sessions
    replaysOnErrorSampleRate: 1.0,  // always record sessions with errors
  })
}

export { Sentry }
